import React, { Fragment } from 'react';
import { isBlank, isPresent } from 'helpers/verify';

export const VARIABLE_REGEX = /(\$[a-zA-Z]\w*)/g;

function interpolateToArray(text, replacementByVariable = {}) {
  if (isBlank(text)) {
    return [];
  }

  /* eslint-disable no-nested-ternary */
  return text
    .split(VARIABLE_REGEX)
    .map(segment =>
      !(VARIABLE_REGEX.test(segment) && segment in replacementByVariable)
        ? segment
        : isPresent(replacementByVariable[segment])
        ? replacementByVariable[segment]
        : ''
    );
  /* eslint-enable no-nested-ternary */
}

export const interpolate = (...args) => interpolateToArray(...args).join('');

export const interpolateToJsx = (...args) =>
  interpolateToArray(...args)
    // eslint-disable-next-line react/no-array-index-key
    .map((bit, idx) => <Fragment key={`${bit}_${idx}`}>{bit}</Fragment>);
